import { render, staticRenderFns } from "./Invite.vue?vue&type=template&id=64b39543"
import script from "./Invite.vue?vue&type=script&lang=js"
export * from "./Invite.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('64b39543')) {
      api.createRecord('64b39543', component.options)
    } else {
      api.reload('64b39543', component.options)
    }
    module.hot.accept("./Invite.vue?vue&type=template&id=64b39543", function () {
      api.rerender('64b39543', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Invite.vue"
export default component.exports